export type MonitoringProviderId = 'logrocket' | 'openreplay';

export type MonitoringUserType = string;

export interface MonitoringConfig {
  readonly enabled: boolean;
  readonly provider: MonitoringProviderId;
  readonly projectKey: string;
  readonly adminSupport: boolean;
}

export interface MonitoringUser {
  readonly userId: string;
  readonly metadata: Readonly<Record<string, string>>;
}

export const MONITORING_PROVIDER_IDS: readonly MonitoringProviderId[] = [
  'logrocket',
  'openreplay',
];

export function isMonitoringProviderId(
  value: string
): value is MonitoringProviderId {
  return MONITORING_PROVIDER_IDS.indexOf(value as MonitoringProviderId) >= 0;
}

export function parseMonitoringConfig(
  raw: Record<string, unknown> | null | undefined
): MonitoringConfig | null {
  if (!raw || !raw['projectKey'] || !raw['provider']) {
    return null;
  }

  const provider = String(raw['provider']);
  if (!isMonitoringProviderId(provider)) {
    return null;
  }

  const projectKey = String(raw['projectKey']).trim();
  if (!projectKey) {
    return null;
  }

  return {
    enabled: !!raw['enabled'],
    provider,
    projectKey,
    adminSupport: !!raw['adminSupport'],
  };
}
